import React, { useState, useRef, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import catalogoPdf from './src/catalogo.pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Dani_monteiro_designer_catalogo: React.FC = () => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [pdfWidth, setPdfWidth] = useState<number>(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const headerHeight = 60;

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    useEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth * 0.9; // 90% da largura
                setPdfWidth(containerWidth);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            {/* Header */}
            <div
                style={{
                    backgroundColor: "#E75480",
                    color: "#fff",
                    padding: "15px 20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    height: headerHeight,
                    flexShrink: 0,
                }}
            >
                <Link to="/dani_monteiro_designer" style={{ color: "#fff", textDecoration: "none" }}>
                    <FiArrowLeft size={24} />
                </Link>
                <h1 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>
                    Catálogo Dani Monteiro
                </h1>
            </div>

            {/* Container do PDF */}
            <div
                ref={containerRef}
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "#f8f8f8",
                    padding: "20px",
                }}
            >
                <Document
                    file={catalogoPdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<p>Carregando PDF...</p>}
                >
                    {numPages &&
                        Array.from({ length: numPages }, (_, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                width={pdfWidth}
                                renderTextLayer={true}
                                renderAnnotationLayer={true}
                            />
                        ))}
                </Document>
            </div>
        </div>
    );
};

export default Dani_monteiro_designer_catalogo;
